import { type } from '@/utils/type'


export const MISSIONVIRTUAL_REQUEST = type('MISSIONVIRTUAL_REQUEST')
export const MISSIONVIRTUAL_SUCCESS = type('MISSIONVIRTUAL_SUCCESS')
export const MISSIONVIRTUAL_ERROR = type('MISSIONVIRTUAL_ERROR')

export const MISSIONVIRTUAL_ENSURE_LIST = type('MISSIONVIRTUAL_ENSURE_LIST')

export const MISSIONVIRTUAL_SELECT_DETAIL_REQUEST = type('MISSIONVIRTUAL_SELECT_DETAIL_REQUEST')
export const MISSIONVIRTUAL_SELECT_DETAIL_SUCCESS = type('MISSIONVIRTUAL_SELECT_DETAIL_SUCCESS')
export const MISSIONVIRTUAL_SELECT_DETAIL_ERROR = type('MISSIONVIRTUAL_SELECT_DETAIL_ERROR')
export const MISSIONVIRTUAL_SELECT_DETAIL = type('MISSIONVIRTUAL_SELECT_DETAIL')

export const MISSIONVIRTUAL_SAVE_REQUEST = type('MISSIONVIRTUAL_SAVE_REQUEST')
export const MISSIONVIRTUAL_SAVE_SUCCESS = type('MISSIONVIRTUAL_SAVE_SUCCESS')
export const MISSIONVIRTUAL_SAVE_ERROR = type('MISSIONVIRTUAL_SAVE_ERROR')

export const MISSIONVIRTUAL_DELETE_REQUEST = type('MISSIONVIRTUAL_DELETE_REQUEST')
export const MISSIONVIRTUAL_DELETE_SUCCESS = type('MISSIONVIRTUAL_DELETE_SUCCESS')
export const MISSIONVIRTUAL_DELETE_ERROR = type('MISSIONVIRTUAL_DELETE_ERROR')


export const MISSIONVIRTUAL_UPDATE_MODIFIED_ADM = type('MISSIONVIRTUAL_UPDATE_MODIFIED_ADM')
export const MISSIONVIRTUAL_CANCEL_MODIFIED_ADM = type('MISSIONVIRTUAL_CANCEL_MODIFIED_ADM')

export const MISSIONVIRTUAL_UPDATE_FILTER_ADM = type('MISSIONVIRTUAL_UPDATE_FILTER_ADM')

export const MISSIONVIRTUAL_PROGRESSION_REQUEST = type('MISSIONVIRTUAL_PROGRESSION_REQUEST')
export const MISSIONVIRTUAL_PROGRESSION_SUCCESS = type('MISSIONVIRTUAL_PROGRESSION_SUCCESS')
export const MISSIONVIRTUAL_PROGRESSION_ERROR = type('MISSIONVIRTUAL_PROGRESSION_ERROR')

export const MISSIONVIRTUAL_UPDATE_PROGRESSION = type('MISSIONVIRTUAL_UPDATE_PROGRESSION')

export const MISSIONVIRTUAL_ENSURE_DATA_SCIENCE = type('MISSIONVIRTUAL_ENSURE_DATA_SCIENCE')
export const MISSIONVIRTUAL_DATA_SCIENCE_REQUEST = type('MISSIONVIRTUAL_DATA_SCIENCE_REQUEST')
export const MISSIONVIRTUAL_DATA_SCIENCE_SUCCESS = type('MISSIONVIRTUAL_DATA_SCIENCE_SUCCESS')
export const MISSIONVIRTUAL_DATA_SCIENCE_ERROR = type('MISSIONVIRTUAL_DATA_SCIENCE_ERROR')

export const MISSIONVIRTUAL_ENSURE_DATA_NAVIGATION = type('MISSIONVIRTUAL_ENSURE_DATA_NAVIGATION')

export const MISSIONVIRTUAL_RESET_SHOW_DIALOG_FINISHED = type('MISSIONVIRTUAL_RESET_SHOW_DIALOG_FINISHED')